module.exports = __webpack_public_path__ + "img/Es-studio.c9e2e0a1.gif";